import type { BootstrapableForm, Option } from "types"
import type { useForm } from "hooks";
import type { BankingSdkConnectorsRecipientsPivot } from "features/openBanking/types";
import { RecipientsPivotFormField } from "../shared";

export const FormField = {
    ...RecipientsPivotFormField,
    RegReportingCodes: 'regReportingCodes',
    PaymentProduct: 'paymentProduct'
} as const;

export type BankingSDKConnectorsRecipientsPivot = {
    readonly [FormField.PaymentProduct]: Option | null;
    readonly [FormField.RegReportingCodes]: object;
} & Pick<
    BankingSdkConnectorsRecipientsPivot,
    | 'bankId'
    | 'recipientId'
    | 'MOR'
    | 'isEnabled'
>;

export type BootstrapData = {
    readonly PaymentProducts: Array<Option>;
};

export type BankingSDKConnectorsRecipientsPivotForm = Omit<
    BootstrapableForm<BankingSDKConnectorsRecipientsPivot, BootstrapData>,
    | 'initialValues'
> & {
    readonly initialValues: BankingSDKConnectorsRecipientsPivot;
    readonly enableReinitialize?: boolean;
};

export type BankingSDKConnectorsRecipientsPivotProps =
    & BankingSDKConnectorsRecipientsPivotForm
    & ReturnType<typeof useForm<BankingSDKConnectorsRecipientsPivot>>;
